import { GridCellParams } from '@/global/components/DataGrid/utils/types'
import { cn } from '@/lib/utils'
import { IconButton } from '@mui/material'
import { Button } from '@/global/components/Button'
import PreviewAnexo, { isImage } from 'global/components/Anexo'
import Dialog from 'global/guides/Dialog'
import { DownloadIcon, PaperclipIcon } from 'lucide-react'
import React, { useState } from 'react'
import { uploads } from 'service/api/endpoints/uploads'

const VisualizarAnexoModal: React.FC<GridCellParams> = ({ value }) => {
    const [open, setOpen] = useState(false)

    if (!value) return null
    const source = `${uploads.URI}/${value}`

    return (
        <>
            <Button onClick={() => setOpen(true)} endIcon={<PaperclipIcon />}>
                Exibir
            </Button>
            <Dialog.Root
                height="75vh"
                open={open}
                onClose={() => setOpen(false)}
            >
                <Dialog.Title>
                    <span className="text-base">Visualizar anexo</span>
                    <IconButton
                        sx={{ float: 'right' }}
                        title="Baixar anexo"
                        href={source}
                        target="_blank"
                        rel="external"
                    >
                        <DownloadIcon />
                    </IconButton>
                </Dialog.Title>
                <Dialog.Content
                    sx={{
                        overflowY: 'clip',
                        maxHeight: '100%',
                        display: 'flex',
                    }}
                >
                    <div
                        className={cn(
                            'm-auto w-full max-h-full overflow-y-clip',
                            isImage(value.split('.').pop()!)
                                ? 'max-w-[22rem]'
                                : 'max-w-[40rem]',
                        )}
                    >
                        <PreviewAnexo
                            source={source}
                            ext={value.split('.').pop()!}
                        />
                    </div>
                </Dialog.Content>
                <Dialog.Actions>
                    <Dialog.Actions.SecondaryButton />
                </Dialog.Actions>
            </Dialog.Root>
        </>
    )
}

export default VisualizarAnexoModal
